module.exports = __webpack_public_path__ + "static/img/shops_d.aa0575f7.jpg";